import { IClientDto } from '../../../core/models/client.dto';

export abstract class ClientSearchMapper {
  static mapForSearch(source: IClientDto): IClientDto {
    if (!source.mobile || source.mobile === '') {
      source.mobile = source.phone;
    } else if (source.phone && source.phone !== '') {
      source.mobile = `${source.mobile} / ${source.phone}`;
    }
    return source;
  }
}
